export default __webpack_public_path__ + "static/media/indiani.67853d10.svg";